import type { ReportingLineDTO } from "@/modules/users/domain/employee-profile.types";

type ProfileReportingLineBlockProps = {
  reportingLine: ReportingLineDTO;
};

export function ProfileReportingLineBlock({
  reportingLine,
}: ProfileReportingLineBlockProps) {
  const { source, displayName, subtitle } = reportingLine;

  if (source === "none") {
    return (
      <p className="text-muted-foreground text-sm">
        ສາຍງານ: ຍັງບໍ່ກຳນົດ (ບໍ່ມີຫົວໜ້າແຜນກ ຫຼື ຕຳແໜ່ງຫົວໜ້າໃນໂຄງສ້າງ)
      </p>
    );
  }

  const label =
    source === "department_manager"
      ? "ຫົວໜ້າແຜນກ"
      : source === "parent_position_holder"
        ? "ຜູ້ບັນຊາການຕາມຕຳແໜ່ງ"
        : "ຕຳແໜ່ງຫົວໜ້າ (ສາຍຕົງ)";

  return (
    <div className="text-sm">
      <p className="text-muted-foreground">
        {label}
        {subtitle ? ` · ${subtitle}` : ""}
      </p>
      {displayName ? (
        <p className="font-medium">{displayName}</p>
      ) : (
        <p className="text-muted-foreground">{subtitle ?? "—"}</p>
      )}
    </div>
  );
}
